module.exports = __webpack_public_path__ + "img/google-play-badge.faf732f0.png";